// extracted by mini-css-extract-plugin
export default {"home":"Home_home__PqZOu","home2":"Home_home2__T7WBY","main":"Home_main__0NSSY"};